import { galleryE6, galleryJ1, galleryJ3 } from "./Galleries";

interface PremiumPlusRouteSetting {
    code: string; premium_product_id: string; base_product_id?: string; course_id?: string;
    start_date?: string; cutoff_date?: string; line_url?: string; second_product?: boolean;
}



export const generateMobileRoutes = (settings: Array<PremiumPlusRouteSetting>) =>
    settings.map(({ code, premium_product_id, base_product_id }) => ({
        path: `/mobile-${code}`,
        props: {
            productId: premium_product_id,
            baseId: base_product_id,
            gallery: galleryMap[code] ?? [],
        },
    }));

const galleryMap: Record<string, any> = {
    e6: galleryE6,
    j1: galleryJ1,
    j3: galleryJ3
};



export const generatePayMobileGuestRoutes = (settings: Array<PremiumPlusRouteSetting>) => {
    return settings.map(setting => ({
        path: `/pay-mobile-guest-${setting.code}`,
        props: {
            productId: setting.premium_product_id,
            roomId: setting.course_id,
            startDate: setting.start_date,
            cutoffDate: setting.cutoff_date,
            lineUrl: setting.line_url,
            secondProduct: Boolean(setting.second_product)
        }
    }));
};



export const generatePayMobilePremiumRoutes = (settings: Array<PremiumPlusRouteSetting>) => {
    return settings.map(setting => ({
        path: `/pay-mobile-premium-${setting.code}`,
        props: {
            productId: setting.premium_product_id,
            roomId: setting.course_id,
            startDate: setting.start_date,
            cutoffDate: setting.cutoff_date,
            lineUrl: setting.line_url,
            secondProduct: Boolean(setting.second_product)
        }
    }));
};



export const generatePayExtensionRoutes = (settings: Array<PremiumPlusRouteSetting>) => {
    return settings.map(setting => ({
        path: `/pay-extension-${setting.code}`,
        props: {
            productId: setting.premium_product_id,
            roomId: setting.course_id,
            cutoffDate: setting.cutoff_date,
            lineUrl: setting.line_url
        }
    }));
};
